module.exports = __webpack_public_path__ + "media/my_images/vision/kv-394ef4e115ceae81b092f87ebc7890c2.jpg";